<template>
  <VCard flat>
    <VForm
      v-model="isValid"
      @submit.prevent="editPersonalInfo"
    >
      <VCardText>
        <VTextField
          v-model="userObj.first_name"
          :error-messages="errorMessages.first_name"
          :label="$nt('firstName')"
          :rules="[$rules.isRequired]"
        />

        <VTextField
          v-model="userObj.last_name"
          :error-messages="errorMessages.last_name"
          :label="$nt('lastName')"
          :rules="[$rules.isRequired]"
        />

        <VSelect
          v-model="userObj.lang"
          :items="languagesList"
          :label="$nt('selectLanguage')"
          :return-object="true"
          :error-messages="errorMessages.lang_id"
          item-text="name"
          item-value="id"
          menu-props="auto"
          hide-details
          @change="changeLanguage"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            {{ langNames[data.item.name] }}
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            {{ langNames[data.item.name] }}
          </template>
        </VSelect>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          color="primary"
          :loading="isLoading"
          type="submit"
          :disabled="isLoading || !isValid"
        >
          {{ $nt('edit') }}
        </VBtn>
      </VCardActions>
    </VForm>
  </VCard>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import auth from '@/utils/auth'
import UserApi from '@/api/UserApi'

import { loadLanguageAsync } from '@/locales/i18n-setup'

export default {
  name: 'PersonalInfoSettings',
  data () {
    return {
      isLoading: false,
      isValid: true,
      errorMessages: {},
      userObj: {},
      langNames: {
        en: 'English',
        ru: 'Русский',
        de: 'Deutsch'
      }
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser',
      languagesList: 'languages/languagesList'
    })
  },
  methods: {
    ...mapActions({
      setUser: 'user/setUser',
      setLanguages: 'languages/setLanguages'
    }),
    async changeLanguage () {
      try {
        localStorage.locale = this.userObj.lang.name
        await loadLanguageAsync(this.userObj.lang.name)
        this.$moment.locale(this.userObj.lang.name)
      } catch (e) {
        this.$notification({
          errors: {
            message: [this.$nt('errorWhileLoadingTranslations')]
          }
        })
      }
    },
    async editPersonalInfo () {
      if (this.isValid) {
        try {
          this.isLoading = true
          const result = await UserApi.updateUser({
            first_name: this.userObj.first_name,
            last_name: this.userObj.last_name,
            lang_id: this.userObj.lang.id
          })

          this.$notification(result)

          const newUserObj = await UserApi.getUser()
          this.setUser(newUserObj)
          auth.user = newUserObj
        } catch (e) {
          this.errorMessages = e.errors
        }
        this.isLoading = false
      }
    }
  },
  watch: {
    userObj: {
      handler () {
        this.errorMessages = {}
      },
      deep: true
    }
  },
  async created () {
    this.setLanguages()
    this.userObj = Object.assign({}, this.getUser)
  }
}
</script>
